module.exports = __webpack_public_path__ + "static/media/logo-linkedin.2e4e2f18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-linkedin.svg
// module id = 553
// module chunks = 0